import { Modal } from "@/components/ui/Modal";
import { QuickSalePage } from "@/pages/pos/QuickSalePage";

interface QuickSaleModalProps {
  open: boolean;
  onClose: () => void;
}

export function QuickSaleModal({ open, onClose }: QuickSaleModalProps) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title="Schnellverkauf"
      description="Verkauf abschließen. Die aktuelle Seite bleibt im Hintergrund."
      size="xl"
      className="eh-modal-panel--tall max-sm:!h-[96dvh] max-sm:!max-h-[96dvh] sm:!w-[min(76rem,calc(100vw-2rem))] sm:!max-w-[min(76rem,calc(100vw-2rem))]"
      bodyClassName="bg-grouped"
    >
      <QuickSalePage embedded />
    </Modal>
  );
}
